import * as types from '../types';

const state = {
    playerState: {
        mapUnit: {
        },
    },
    UIState: {
        blockGameplayMap: {},
    },
};

const getters = {
    [types.GET_PLAYER_STATE]: state => {
        return state.playerState;
    },
    [types.GET_UI_BLOCK_GAMEPLAY_MAP]: state => {
        return state.UIState.blockGameplayMap;
    },    
};

const mutations = {
    [types.REGISTER_BLOCK_GAMEPLAY_UI]: (state, payload) => {      
        state.UIState.blockGameplayMap[payload.key] = true;
    },
    [types.UNREGISTER_BLOCK_GAMEPLAY_UI]: (state, payload) => {        
        delete state.UIState.blockGameplayMap[payload.key];
    },
};

const actions = {

};

export default {
    state,
    getters,
    mutations,
    actions,
}